/* eslint-disable */
import anime from 'animejs';
import loadMore from './load-more.js'

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {

    /* Accordion component*/
    var acc = document.getElementsByClassName('accordion-item');
    var accordionTransition = 200;
    // var i;
    var isReset = false;

    function closeAccordion(el) {
      anime({
        targets: ['.accordion-item.active .panel'],
        translateY: [0, '-2rem'],
        opacity: [1, 0.01],
        easing: 'easeInOutCubic',
        duration: accordionTransition
      });

      el.find('.arrow').removeClass('arrow-up').addClass('arrow-down');

      setTimeout(() => {
        el.removeClass('active');
      }, accordionTransition);
    }

    function openAccordion(el) {
      if ($('.accordion-item.active').length) {
        closeAccordion($('.accordion-item.active'));
      }

      el.addClass('active');
      el.find('.arrow').removeClass('arrow-down').addClass('arrow-up');

      anime({
        targets: ['.accordion-item.active .panel'],
        translateY: ['-2rem', 0],
        opacity: [0.01, 1],
        easing: 'easeInOutCubic',
        duration: accordionTransition
      });
    }

    $('.accordion-item .accordion-button, .accordion-item .plus-button').on('click', function() {
      $(this).closest('.component.accordion').find('.accordion-wrapper').css({'max-height': '' });

      var activeEl = $(this).closest('.accordion-item');

      if (activeEl.hasClass('active')) {
        closeAccordion(activeEl);
      } else {
        if ($('.accordion-item.active').length) {
          closeAccordion($('.accordion-item.active'));

          setTimeout(() => {
            openAccordion(activeEl);
          }, accordionTransition);
        } else {
          openAccordion(activeEl);
        }
      }
    });

    $( ".accordion-show-more" ).click(function(event) {
      // parent component needs class .component, as well as data-element-count.
      // items must be wrapped in .items-wrapper
      // function needs the trigger, and a child selector.
      loadMore.handle($(this), '.accordion-item');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/accordion.js